import * as api from '../api';
import { FETCH_HISTORIC_MESSAGES, GET_CHATS, SHOW_CHAT, SHOW_CHAT_NOTIFICATIONS, START_CHAT } from '../constants/actionTypes';

export const getChats = (id, page, cb) => async (dispatch ) => {

    let error = null; 
    let res = null; 

    try {

        const {data} = await api.fetchChats(id, page); 

        dispatch({
            type: GET_CHATS,
            data
        });

        console.log('get chats data: ', data);

        res = data; 

    } catch (err) {
        console.warn(err);

        error = err; 
    }

    if(typeof cb === 'function'){

        cb(error, res);

    }
}

export const getHistoricMessages = (id, chatRoomId, page=1, cb) => async (dispatch ) => {

    let error = null; 
    let res = null; 

    try {

        const {data} = await api.fetchHistoricMessages(id, chatRoomId, page); 

        dispatch({
            type: FETCH_HISTORIC_MESSAGES,
            data
        });

        console.log('get historic messages data: ', data);

        res = data; 

    } catch (err) {
        console.warn(err);

        error = err; 
    }

    if(typeof cb === 'function'){

        cb(error, res);

    }
}


export const startChat = (id, chatData, cb) => async (dispatch ) => {

    let error = null; 
    let res = null; 

    try {

        const {data} = await api.startChat(id, chatData); 

        dispatch({
            type: START_CHAT,
            data
        });

        console.log('start chat data: ', data);

        res = data; 

    } catch (err) {
        console.warn(err);

        error = err; 
    }

    if(typeof cb === 'function'){

        cb(error, res);

    }
}

